// Build-time prerendered pages (tools/seo/prerender.mjs) ship their rendered
// body inside #root, flagged `data-prerendered`. React clears #root on its
// first commit, which is usually a Suspense spinner while the page chunk
// loads — so a visitor would see content, then a spinner, then content again.
// Instead the snapshot moves out of #root into a sibling that stays on screen
// while the app renders hidden, and is swapped out once the app has rendered
// the page's own <h1> (the same readiness signal the prerender waits for).

const SNAPSHOT_ID = "prerender-snapshot";
/** Reveal anyway after this long, so a page that never renders an <h1> can't stay hidden. */
export const REVEAL_FALLBACK_MS = 8000;

/** Call before createRoot(). No-op unless #root carries a prerendered snapshot. */
export function adoptPrerenderSnapshot(root: HTMLElement): void {
  if (!root.hasAttribute("data-prerendered")) return;
  root.removeAttribute("data-prerendered");
  const snapshot = document.createElement("div");
  snapshot.id = SNAPSHOT_ID;
  snapshot.setAttribute("aria-hidden", "true");
  while (root.firstChild) snapshot.appendChild(root.firstChild);
  root.before(snapshot);
  root.style.display = "none";

  const reveal = () => {
    observer.disconnect();
    window.clearTimeout(timer);
    snapshot.remove();
    root.style.removeProperty("display");
  };
  const observer = new MutationObserver(() => {
    if (root.querySelector("h1")) reveal();
  });
  observer.observe(root, { childList: true, subtree: true });
  const timer = window.setTimeout(reveal, REVEAL_FALLBACK_MS);
}
